import Repository from '@/api/Repository';
import { SerialDuplicateError } from '@/api/user/erros';

export default {
  getDevices(token, groupID) {
    if (groupID === 'all') {
      return Repository.get('/Infrastructure/ManageDevices', {
        headers: {
          Authorization: token,
        },
      }).then(response => response.data);
    }
    return Repository.get(`/Infrastructure/ManageDevices?groupId=${groupID}`, {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data);
  },
  getDevicesWithShops(token, groupID) {
    if (groupID === 'all') {
      return Repository.get('/Infrastructure/ManageDevices?withShops=true', {
        headers: {
          Authorization: token,
        },
      }).then(response => response.data);
    }
    return Repository.get(`/Infrastructure/ManageDevices?groupId=${groupID}&withShops=true`, {
      headers: {
        Authorization: token,
      },
    }).then(response => response.data);
  },
  getShopsForDevices(token) {
    return Repository.get('/Infrastructure/Shops', {
      headers: {
        Authorization: token,
      },
    }).then(response => this.remapObjectResponse(response.data));
  },
  devicesCrud(token, payload) {
    return Repository.post('/Infrastructure/ManageDevices', payload, {
      headers: {
        Authorization: token,
      },
    }).then(response => response);
  },
  getDevicesMockup(groupID) {
    if (groupID === 1) {
      return [
        {
          id: 19,
          name: 'Centralka - sala konferencyjna',
          serialNumber: '321',
          bidirectional: false,
          versionNumber: '1.42|home',
          enabled: true,
          lastActivation: '2017-09-11T16:13:50.68',
          shopId: 3,
        },
        {
          id: 1,
          name: 'Centralka demo 001',
          serialNumber: '69b',
          bidirectional: false,
          versionNumber: '1.42|home',
          enabled: true,
          lastActivation: '2018-04-05T15:45:59.507',
          shopId: 1,
        },
        {
          id: 10,
          name: 'Centralka demo 002',
          serialNumber: '586',
          bidirectional: false,
          versionNumber: '1.42|home',
          enabled: true,
          lastActivation: '2018-08-28T10:00:52.71',
          shopId: 1,
        },
        {
          id: 45,
          name: 'nowa centralka z sensorami',
          serialNumber: 'serial12356',
          bidirectional: true,
          versionNumber: '2',
          enabled: true,
          lastActivation: '2019-06-24T19:55:41.343',
          shopId: 7,
        },
      ];
    }
    return [
      {
        id: 1,
        name: 'Centralka demo 001',
        serialNumber: '69b',
        bidirectional: false,
        versionNumber: '1.42|home',
        enabled: true,
        lastActivation: '2018-04-05T15:45:59.507',
        shopId: 1,
      },
      {
        id: 10,
        name: 'Centralka demo 002',
        serialNumber: '586',
        bidirectional: false,
        versionNumber: '1.42|home',
        enabled: true,
        lastActivation: '2018-08-28T10:00:52.71',
        shopId: 1,
      },
      {
        id: 45,
        name: 'nowa centralka z sensorami',
        serialNumber: 'serial12356',
        bidirectional: true,
        versionNumber: '2',
        enabled: true,
        lastActivation: '2019-06-24T19:55:41.343',
        shopId: 7,
      },
    ];
  },
  getShopsForDevicesMockup() {
    return this.remapObjectResponse({
      3: 'Sala konferencyjna',
      2: 'Salon Demo 2',
      7: 'nowy salon',
      1: 'rasbery pi',
    });
  },
  remapObjectResponse(input) {
    return Object.keys(input)
      .map(key => ({
        id: Number(key),
        name: input[key],
      }));
  },
  validateSerials(token, payload) {
    return Repository.post('/Infrastructure/ManageDevices/validate', payload, {
      headers: {
        Authorization: token,
        'Content-Type':
          'application/json',
      },
    })
      .then(response => response.data)
      .catch((error) => {
        if (error.response.data.code === 'POINT_SERIAL_DUPLICATED') {
          throw new SerialDuplicateError();
        } else {
          throw new Error('Error');
        }
      });
  },
  deviceMap(token, groupId) {
    return Repository.get(`/Infrastructure/sensors?groupId=${groupId}`, {
      headers: {
        Authorization: token,
        'Content-Type':
          'application/json',
      },
    })
      .then(response => this.remapObjectResponse(response.data))
      .catch(e => e);
  },
};
